import {
  GET_VAIX_SEARCH_PRE_SEARCH_REQUEST,
  GET_VAIX_SEARCH_PRE_SEARCH_SUCCESS,
  GET_VAIX_SEARCH_PRE_SEARCH_FAILURE,
  GET_VAIX_SEARCH_AFTER_SEARCH_REQUEST,
  GET_VAIX_SEARCH_AFTER_SEARCH_SUCCESS,
  GET_VAIX_SEARCH_AFTER_SEARCH_FAILURE,
  GET_VAIX_SEARCH_AFTER_SEARCH_GAMELIST_EVENT_REQUEST,
  GET_VAIX_SEARCH_AFTER_SEARCH_GAMELIST_EVENT_SUCCESS,
  GET_VAIX_SEARCH_AFTER_SEARCH_GAMELIST_EVENT_FAILURE
} from 'Store/constants';

const initialState = {
  loading: false,
  error: null,
  preSearchData: null,
  afterSearchData: null,
  gameListData: null
};

export default function vaixSearchReducer (state = initialState, action) {
  switch (action.type) {
    case GET_VAIX_SEARCH_PRE_SEARCH_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case GET_VAIX_SEARCH_PRE_SEARCH_SUCCESS:
      return {
        ...state,
        loading: false,
        preSearchData: action.payload,
        error: null
      };
    case GET_VAIX_SEARCH_PRE_SEARCH_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case GET_VAIX_SEARCH_AFTER_SEARCH_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case GET_VAIX_SEARCH_AFTER_SEARCH_SUCCESS:
      return {
        ...state,
        loading: false,
        afterSearchData: action.payload,
        error: null
      };
    case GET_VAIX_SEARCH_AFTER_SEARCH_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    case GET_VAIX_SEARCH_AFTER_SEARCH_GAMELIST_EVENT_REQUEST:
      return {
        ...state,
        loading: true,
        error: null
      };
    case GET_VAIX_SEARCH_AFTER_SEARCH_GAMELIST_EVENT_SUCCESS:
      return {
        ...state,
        loading: false,
        gameListData: action.payload,
        error: null
      };
    case GET_VAIX_SEARCH_AFTER_SEARCH_GAMELIST_EVENT_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload
      };
    default:
      return state;
  }
}
